module.exports = __webpack_public_path__ + "img/about_banner.7b85a1ec.png";